import Vue from 'vue'
import Vuex from 'vuex'
import User from './modules/user.js'
import Report from './modules/report.js'
import Struct from './modules/structura.js'
import Admin from './modules/admin.js'
import Schedules from './modules/schedules.js'
import app from '@/app.js'
import moment from "moment";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    settings: null,
    bin: "",
    sCurrency: "€",
    rules: null,
    iface: 1,
    editor: 0,
    namedays: []
  },
  actions: {
    LOAD_NAMEDAYS: (context) => {
      app.getNamedays().then((response) => {
        context.commit("setNamedays", response.data);
      });
    },
  },
  mutations: {
    setSettings: (state, payload) => {
      state.rules = payload.rules;
      state.bin = "";
      state.sCurrency = payload.currency;
      try {
        state.bin = /<bin>(\d+)<\/bin>/g.exec(state.rules)[1];
        // eslint-disable-next-line
      } catch (e) {
        state.bin = "";
      }
      try {
        state.iface = /<interface>(\d)<\/interface>/g.exec(state.rules)[1];
        // eslint-disable-next-line
      } catch (e) {
        state.iface = 1;
      }
      try {
        state.editor = /<editor>(\d)<\/editor>/g.exec(state.rules)[1];
        // eslint-disable-next-line
      } catch (e) {
        state.editor = 0;
      }
    },
    setIface: (state, payload) => {
      state.iface = payload;
    },
    setNamedays: (state, payload) => {
      let day = moment();
      for (let i = 0; i < 7; i++) {
        state.namedays.push(payload[day.month()][day.date()-1]);
        day = day.add(1, "days");
      }
    },
    clearSettings: (state) => {
      state.settings = null;
      state.bin = "";
      state.rules = "";
    }
  },
  getters: {
    settings: state => {
      return state.settings;
    },
    namedays: state => {
      return state.namedays;
    },
    iface: state => {
      return state.iface;
    },
    editor_type: state => {
      return state.editor;
    },
    userbin: state => {
      return state.bin;
    },
    sCurrency: state => {
      return state.sCurrency;
    },
    /*    smsuser: state=>{
          try {
            return /<smsu>(.+)<\/smsu>/g.exec(state.rules)[1];
          } catch (e) {
            return "";
          }
        },
        smspass: state=>{
          try {
            return /<smsp>(.+)<\/smsp>/g.exec(state.rules)[1];
          } catch (e) {
            return "";
          }
        },*/
    getrule: state => {
      return rule => {
        try {
          if (!rule) return "";
          if (!state.rules) return "";
          rule = rule.trim();
          if (!rule) return "";
          let res = new RegExp("<" + rule + ">(.*)</" + rule + ">", "gi").exec(state.rules);
          return res ? res[1] : "";
        } catch (e) {
          console.error(e);
        }
        return false;
      }
    },
    test: state => {
      return rule => {
        try {
          if (!rule) return true;
          if (!state.rules) return false;
          let retResult = true;
          rule.split(",").forEach(el => {
            el = el.trim();
            if (!el) return;
            let r = el.split(".");
            if (r.length == 1) r[1] = "r";
            retResult = retResult && new RegExp("<" + r[0] + ">\\w*" + r[1] + "\\w*</" + r[0] + ">", "gi").test(state.rules);
            //  if (!retResult) {
            //    console.log("blocked", rule, retResult, state.rules);
            //  }
          })
          return retResult;
        } catch (e) {
          console.error(e);
        }
        return false;
      }
    },
    testOr: state => {
      return rule => {
        try {
          if (!rule) return true;
          if (!state.rules) return false;
          let retResult = true;
          rule.split(",").forEach(el => {
            el = el.trim();
            if (!el) return;
            let r = el.split(".");
            if (r.length == 1) r[1] = "r";
            retResult = retResult || new RegExp("<" + r[0] + ">\\w*" + r[1] + "\\w*</" + r[0] + ">", "gi").test(state.rules);
              if (!retResult) {
                console.log("blocked", rule, retResult, state.rules);
              }
          })
          return retResult;
        } catch (e) {
          console.error(e);
        }
        return false;
      }
    }
  },
  modules: {
    user: User,
    struct: Struct,
    report: Report,
    admin: Admin,
    schedules: Schedules,
  }
})
